// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__mFzpm","modal":"Modal_modal__uOAsL","slide-down":"Modal_slide-down__tOZf7","submodal":"Modal_submodal__G2HMt"};